export const FETCH_SOCIAL_NETWORKS_LIST = 'SOCIAL/FETCH_SOCIAL_NETWORKS_LIST';
export const FETCH_SOCIAL_NETWORKS_LIST_ERROR = 'SOCIAL/FETCH_SOCIAL_NETWORKS_LIST_ERROR';
export const CLEAR_FETCH_SOCIAL_NETWORKS_LIST = 'SOCIAL/CLEAR_FETCH_SOCIAL_NETWORKS_LIST';

export const FETCH_SOCIAL_LINKS_LIST = 'SOCIAL/FETCH_SOCIAL_LINKS_LIST';
export const FETCH_SOCIAL_LINKS_LIST_ERROR = 'SOCIAL/FETCH_SOCIAL_LINKS_LIST_ERROR';
export const CLEAR_FETCH_SOCIAL_LINKS_LIST = 'SOCIAL/CLEAR_FETCH_SOCIAL_LINKS_LIST';

export const CREATE_SOCIAL_LINK_SUCCESS = 'SOCIAL/CREATE_SOCIAL_LINK_SUCCESS';
export const CREATE_SOCIAL_LINK_ERROR = 'SOCIAL/CREATE_SOCIAL_LINK_ERROR';
export const CLEAR_CREATE_SOCIAL_LINK = 'SOCIAL/CLEAR_CREATE_SOCIAL_LINK';

export const PATCH_SOCIAL_LINK_SUCCESS = 'SOCIAL/PATCH_SOCIAL_LINK_SUCCESS';
export const PATCH_SOCIAL_LINK_ERROR = 'SOCIAL/PATCH_SOCIAL_LINK_ERROR';
export const CLEAR_PATCH_SOCIAL_LINK = 'SOCIAL/CLEAR_PATCH_SOCIAL_LINK';

export const DELETE_SOCIAL_LINK_SUCCESS = 'SOCIAL/DELETE_SOCIAL_LINK_SUCCESS';
export const DELETE_SOCIAL_LINK_ERROR = 'SOCIAL/DELETE_SOCIAL_LINK_ERROR';
export const CLEAR_DELETE_SOCIAL_LINK = 'SOCIAL/CLEAR_DELETE_SOCIAL_LINK';

export const APPLY_SOCIAL_LINK_DRAG = 'SOCIAL/APPLY_SOCIAL_LINK_DRAG';
export const APPLY_SOCIAL_LINK_DRAG_ERROR = 'SOCIAL/APPLY_SOCIAL_LINK_DRAG_ERROR';
export const CLEAR_SOCIAL_LINK_DRAG = 'SOCIAL/CLEAR_SOCIAL_LINK_DRAG';
